import { render, staticRenderFns } from "./comStep1.vue?vue&type=template&id=1914d6c8&scoped=true&"
import script from "./comStep1.vue?vue&type=script&lang=js&"
export * from "./comStep1.vue?vue&type=script&lang=js&"
import style0 from "./comStep1.vue?vue&type=style&index=0&id=1914d6c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1914d6c8",
  null
  
)

export default component.exports